import React, { useMemo } from 'react';
import { ColumnGroup } from '../../../components/datagridComponents/GridColumns';
import { SidekickDataGridConfigContextProvider } from '../../../context/SidekickDataGridConfigContext';

const ProductTableCompleteWrapper = ({ children }: { children: JSX.Element }) => {
  const columnVisibility = useMemo(
    () => ({
      name: true,
      description: true,
      categoryId: true,
      salePriceIncTax: true,
      costPriceIncTax: true,
      barcode: false,
      sku: false,
    }),
    []
  );

  const columnGroups: ColumnGroup[] = useMemo(
    () => [
      {
        name: 'generic',
        entries: ['name', 'description', 'categoryId'],
      },
      {
        name: 'price',
        entries: ['salePriceIncTax', 'costPriceIncTax'],
      },
      { name: 'extra', entries: ['barcode', 'sku'] },
    ],
    []
  );

  return (
    <SidekickDataGridConfigContextProvider
      translationKey="csvColumns"
      columnVisibility={columnVisibility}
      columnGroups={columnGroups}
    >
      {children}
    </SidekickDataGridConfigContextProvider>
  );
};
export default ProductTableCompleteWrapper;
